import React from 'react';
import PropTypes from 'prop-types';

export default function GovernmentLandIcon({ color = '#ffffff', width = 20, height = 20 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={width} height={height} fill={color}>
      <path d="M426.7 128h64v42.7H469.3V405.3h21.3V448H21.3V405.3H42.7V170.7H21.3V128h64V85.3c0-5.7 2.2-11.1 6.2-15.1s9.4-6.2 15.1-6.2H405.3c5.7 0 11.1 2.2 15.1 6.2s6.2 9.4 6.2 15.1V128zm0 42.7H85.3V405.3h64V256H192V405.3h42.7V256h42.7V405.3H320V256h42.7V405.3h64V170.7zM128 106.7V128H384V106.7H128z" />
    </svg>
  );
}

GovernmentLandIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};
